// extracted by mini-css-extract-plugin
module.exports = {"Caddy":"StickyContainer_Caddy__VKYAZ","Wrapper":"StickyContainer_Wrapper___T8Eb"};